import React, {useEffect, useState} from 'react';
import MessageBroker from '@bonprix/pattern-library/components/message-broker';
import CoreMessages from '../messages';
import {Dialog, Typography} from '@bonprix/design-system';

export default function CheckoutErrorLayer({texts, layerId}) {
    const [open, setOpen] = useState(true);

    useEffect(() => {
        MessageBroker.subscribe(CoreMessages.LAYER.OPEN, (data) => {
            if (layerId === data.layerId) {
                setOpen(true);
            }
        });
    }, []);

    const close = () => setOpen(false);

    return (
        <Dialog zIndex={999} isOpen={open} onClose={close}>
            <Dialog.Title>{texts.cart_error_layer_headline}</Dialog.Title>
            <Dialog.Content>
                <Typography>{texts.cart_error_layer_text}</Typography>
                <Typography>{texts.cart_error_layer_retry}</Typography>
            </Dialog.Content>
        </Dialog>
    );
}
